// Diagramas ilustrativos propios de Klarvi (no son capturas reales del portal del IMSS ni de ninguna
// AFORE). Sirven únicamente para orientar al usuario sobre en qué parte de su documento suele
// aparecer cada dato que le pedimos capturar a mano.

const PAPER_WIDTH = 480;
const PAPER_HEIGHT = 320;

function PaperFrame({ children, docLabel }) {
  return (
    <svg
      viewBox={`0 0 ${PAPER_WIDTH} ${PAPER_HEIGHT}`}
      className="w-full h-auto rounded-lg border bg-white"
      role="img"
      aria-label={docLabel}
    >
      <rect x="0" y="0" width={PAPER_WIDTH} height={PAPER_HEIGHT} fill="#FFFFFF" />
      <rect x="0" y="0" width={PAPER_WIDTH} height="40" fill="#0F172A" />
      <text x="16" y="25" fill="#F8FAFC" fontSize="13" fontFamily="Manrope, sans-serif" fontWeight="700">
        {docLabel}
      </text>
      {children}
      <text
        x={PAPER_WIDTH / 2}
        y={PAPER_HEIGHT - 10}
        fill="#94A3B8"
        fontSize="10"
        fontFamily="Inter, sans-serif"
        textAnchor="middle"
        letterSpacing="1"
      >
        EJEMPLO ILUSTRATIVO — NO ES UNA CAPTURA REAL DEL PORTAL
      </text>
    </svg>
  );
}

function FieldRow({ y, label, value, highlighted }) {
  return (
    <g>
      {highlighted && (
        <rect
          x="10"
          y={y - 16}
          width={PAPER_WIDTH - 20}
          height="28"
          rx="6"
          fill="#EFF6FF"
          stroke="#2563EB"
          strokeWidth="2"
        />
      )}
      <text x="20" y={y + 2} fill="#475569" fontSize="12" fontFamily="Inter, sans-serif">
        {label}
      </text>
      <text
        x={PAPER_WIDTH - 20}
        y={y + 2}
        fill={highlighted ? '#1D4ED8' : '#0F172A'}
        fontSize="12"
        fontFamily="Inter, sans-serif"
        fontWeight={highlighted ? '700' : '500'}
        textAnchor="end"
      >
        {value}
      </text>
      {highlighted && (
        <text x="20" y={y + 20} fill="#2563EB" fontSize="10" fontFamily="Inter, sans-serif" fontWeight="600">
          ← aquí lo encuentras
        </text>
      )}
    </g>
  );
}

const CONSTANCIA_ROWS = [
  { key: 'nombre', label: 'Nombre', value: 'JUAN PÉREZ GÓMEZ' },
  { key: 'curp', label: 'CURP', value: 'PEGJ850101HDFRXX01' },
  { key: 'nss', label: 'Número de Seguridad Social (NSS)', value: '12345678901' },
  { key: 'fecha_primera', label: 'Fecha de tu primer registro ante el IMSS', value: '15/03/1995' },
  { key: 'semanas', label: 'Semanas cotizadas', value: '812' },
  { key: 'semanas_descontadas', label: 'Semanas descontadas', value: '4' },
  { key: 'sbc', label: 'Salario Base de Cotización (SBC) más reciente', value: '$487.12 / día' },
];

export function ConstanciaSemanasMockup({ highlight }) {
  const rowHeight = 36;
  const startY = 68;
  return (
    <PaperFrame docLabel="Constancia de Semanas Cotizadas (IMSS)">
      {CONSTANCIA_ROWS.map((row, i) => (
        <FieldRow
          key={row.key}
          y={startY + i * rowHeight}
          label={row.label}
          value={row.value}
          highlighted={row.key === highlight}
        />
      ))}
    </PaperFrame>
  );
}

const AFORE_ROWS = [
  { key: 'retiro_rcv', label: 'Retiro, Cesantía y Vejez (RCV)', value: '$142,380.55' },
  { key: 'vivienda', label: 'Vivienda', value: '$63,910.20' },
  { key: 'voluntario', label: 'Aportaciones voluntarias / complementarias', value: '$8,420.00' },
  { key: 'total', label: 'Saldo total', value: '$214,710.75' },
];

export function AforeEstadoCuentaMockup({ highlight }) {
  const rowHeight = 40;
  const startY = 76;
  return (
    <PaperFrame docLabel="Estado de Cuenta AFORE">
      <text x="20" y="58" fill="#0F172A" fontSize="12" fontFamily="Manrope, sans-serif" fontWeight="700">
        Saldo por subcuenta
      </text>
      {AFORE_ROWS.map((row, i) => (
        <FieldRow
          key={row.key}
          y={startY + i * rowHeight}
          label={row.label}
          value={row.value}
          highlighted={highlight === 'saldo_afore' && row.key !== 'total'}
        />
      ))}
    </PaperFrame>
  );
}
